import { Component } from '@angular/core';
// import { SearchWidgetComponent } from 'src/app/components/karve/search-widget/search-widget.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-hero',
  standalone: true,
  imports: [],
  templateUrl: './hero.component.html',
  styleUrl: './hero.component.scss',
})
export class HeroComponent {
  logoSrc = 'logo-main-horizontal-full-v2.jpg';

  constructor(private router: Router) {
    if (
      ['/furgonetas', '/vans', '/home', '/inicio'].includes(this.router.url)
    ) {
      this.logoSrc = 'logo-main-horizontal-full-v2.jpg';
    }
  }
}
